import { ArrayValue, BooleanValue, NumberValue, RecordValue, StringValue, Value, } from '@coveo/bueno';
import { createAction } from '@reduxjs/toolkit';
import { allowedValues, customSort, } from '../../../controllers/core/facets/_common/facet-option-definitions.js';
import { validatePayload } from '../../../utils/validate-payload.js';
import { facetIdDefinition } from '../generic/facet-actions-validation.js';
import { facetValueDefinition } from './facet-set-validate-payload.js';
const facetRegistrationOptionsDefinition = {
    facetId: facetIdDefinition,
    field: new StringValue({ required: true, emptyAllowed: true }),
    tabs: new RecordValue({
        options: {
            required: false,
        },
        values: {
            included: new ArrayValue({ each: new StringValue() }),
            excluded: new ArrayValue({ each: new StringValue() }),
        },
    }),
    activeTab: new StringValue({ required: false }),
    filterFacetCount: new BooleanValue({ required: false }),
    injectionDepth: new NumberValue({ required: false, min: 0 }),
    numberOfValues: new NumberValue({ required: false, min: 1 }),
    sortCriteria: new Value({ required: false }),
    resultsMustMatch: new Value({ required: false }),
    allowedValues: allowedValues,
    customSort: customSort,
};
export const registerFacet = createAction('facet/register', (payload) => validatePayload(payload, facetRegistrationOptionsDefinition));
export const toggleSelectFacetValue = createAction('facet/toggleSelectValue', (payload) => validatePayload(payload, {
    facetId: facetIdDefinition,
    selection: new RecordValue({ values: facetValueDefinition }),
}));
export const toggleExcludeFacetValue = createAction('facet/toggleExcludeValue', (payload) => validatePayload(payload, {
    facetId: facetIdDefinition,
    selection: new RecordValue({ values: facetValueDefinition }),
}));
export const deselectAllFacetValues = createAction('facet/deselectAll', (payload) => validatePayload(payload, facetIdDefinition));
export const updateFacetSortCriterion = createAction('facet/updateSortCriterion', (payload) => validatePayload(payload, {
    facetId: facetIdDefinition,
    criterion: new Value({ required: true }),
}));
export const updateFacetNumberOfValues = createAction('facet/updateNumberOfValues', (payload) => validatePayload(payload, {
    facetId: facetIdDefinition,
    numberOfValues: new NumberValue({ required: true, min: 1 }),
}));
export const updateFacetIsFieldExpanded = createAction('facet/updateIsFieldExpanded', (payload) => validatePayload(payload, {
    facetId: facetIdDefinition,
    isFieldExpanded: new BooleanValue({ required: true }),
}));
export const updateFreezeCurrentValues = createAction('facet/updateFreezeCurrentValues', (payload) => validatePayload(payload, {
    facetId: facetIdDefinition,
    freezeCurrentValues: new BooleanValue({ required: true }),
}));
